import PdfWebViewer from './PdfWebViewer';

export default PdfWebViewer;